export default __webpack_public_path__ + "static/media/prib.edafeb33.pdf";